import { Row, Col, Card } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useFormContext } from "react-hook-form";

function Quotation() {
  const methods = useFormContext();
  const { getValues } = methods;

  return (
    <div>
      <Row>
        <Card.Body>
          <Row className="mb-2">
            <Col className="text-black-50">
              <FormattedMessage id="shipment-quotes.components.bookQuoteDialog.price" defaultMessage="Price" />
            </Col>
            <Col>
              {getValues("quotation.price")} {getValues("quotation.currency_code")}
            </Col>
          </Row>
          <Row className="mb-2">
            <Col className="text-black-50">
              <FormattedMessage id="quote-request.costDetailChargeableWeight" defaultMessage="Chargeable weight" />
            </Col>
            <Col>{getValues("quotation.chargeable_weight")}</Col>
          </Row>
          {getValues("quotation.weight") && (
            <Row className="mb-2">
              <Col className="text-black-50">
                <FormattedMessage id="shipments.weight" defaultMessage="Weight" />
              </Col>
              <Col>{getValues("quotation.weight")} Kg</Col>
            </Row>
          )}
          {getValues("quotation.volume") && (
            <Row className="mb-2">
              <Col className="text-black-50">
                <FormattedMessage id="shipments.Volume" defaultMessage="Volume" />
              </Col>
              <Col>
                {getValues("quotation.volume")} m<sup>3</sup>
              </Col>
            </Row>
          )}
        </Card.Body>
      </Row>
    </div>
  );
}

export default Quotation;
